import { useEffect } from 'react'

interface useInitCarriersProps {
  getRows: Function
  setRows: Function
  setDeleteEntryId: Function
  setShowModal: Function
  setShowOverlay: Function
}

const useInit = (props: useInitCarriersProps) => {
  useEffect(() => {
    props
      .getRows({
        setDeleteEntryId: props.setDeleteEntryId,
        setShowModal: props.setShowModal,
      })
      .then((data: any) => {
        props.setRows(data)
        props.setShowOverlay(false)
      })
  }, [])
}

export default useInit
